import React, { useContext } from 'react'
import Modal from 'react-modal'
import clx from 'classnames'
import EquipmentBox from 'app/React/Components/Form/EquipmentBox'
import WidgetForm from 'app/React/Components/Widget/WidgetForm'
import WidgetStepFigure from 'app/React/Components/Widget/WidgetStepFigure'
import WidgetButtonLine from 'app/React/Components/Widget/WidgetButtonLine'
import ConfiguratorContainer, { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function ConfiguratorWidget(props) {
  const {
    currentVariant
  } = useContext(ConfiguratorContext)

  Modal.setAppElement('body')

  return (
    <ConfiguratorContainer {...props}>
      <div
        id='mg-configurator'
        className={clx(
          'mtt-product',
          'mtt-product--configurator',
          props.spacing.spacing_bottom,
          props.spacing.spacing_top,
          'mtt-product--direction-' + props.direction,
          { 'spacing-classes-added': props.spacing.spacing_bottom || props.spacing.spacing_top }
        )}
      >
        <div id='step-1' className='mtt-product__inner page_container'>
          <WidgetForm form={currentVariant.steps['1']} variantsetting paymenttypesetting>
            <EquipmentBox/>
            <WidgetButtonLine
              leftButtonText={props.left_button.text}
              rightButtonText={props.right_button.text}
              leftButtonUrl={props.left_button.url}
              rightButtonUrl={props.right_button.url}
            />
          </WidgetForm>
          <WidgetStepFigure step={currentVariant.steps['1'].step_id} isWidget/>
        </div>
      </div>
    </ConfiguratorContainer>
  )
}
